var map = {
	"./404.svg": "a14a",
	"./address.svg": "0e25",
	"./arrow-left.svg": "12e3",
	"./arrow-right.svg": "6929",
	"./bug.svg": "1779",
	"./cart-circle-disabled.svg": "70d2",
	"./cart-circle.svg": "dee6",
	"./cart.svg": "908e",
	"./chart.svg": "c829",
	"./clipboard.svg": "bc35",
	"./component.svg": "56d6",
	"./contact.svg": "cf63",
	"./dashboard.svg": "f782",
	"./delete.svg": "59a1",
	"./documentation.svg": "90fb",
	"./drag.svg": "9bbf",
	"./edit.svg": "aa46",
	"./email.svg": "cbb7",
	"./example.svg": "30c3",
	"./excel.svg": "6599",
	"./eye.svg": "4df5",
	"./form.svg": "eb1b",
	"./guide 2.svg": "2027",
	"./guide.svg": "6683",
	"./help.svg": "c932",
	"./icon.svg": "9d91",
	"./international.svg": "17df",
	"./language.svg": "2580",
	"./link.svg": "18f0",
	"./list.svg": "3289",
	"./lock.svg": "ab00",
	"./login-user.svg": "2815",
	"./member.svg": "daf4",
	"./message-success.svg": "90d3",
	"./message.svg": "47ff",
	"./money.svg": "3046",
	"./nested.svg": "dcf8",
	"./password.svg": "2a3d",
	"./pdf.svg": "f9a1",
	"./people.svg": "d056",
	"./peoples.svg": "2f11",
	"./phone.svg": "dd82",
	"./qq.svg": "1430",
	"./search.svg": "8e8d",
	"./shipping.svg": "e8ae",
	"./shopping.svg": "12a5",
	"./size.svg": "8644",
	"./sort-asc.svg": "947c",
	"./sort-desc.svg": "2552",
	"./sort.svg": "e528",
	"./star.svg": "708a",
	"./tab.svg": "8fb7",
	"./table.svg": "47f1",
	"./theme.svg": "e534",
	"./tree.svg": "93cd",
	"./user.svg": "b3b5",
	"./wechat.svg": "80da",
	"./zip.svg": "8aa6"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	var id = map[req];
	if(!(id + 1)) { // check for number or string
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return id;
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "51ff";